import { Link } from 'react-router-dom';
import { ShieldCheck, Cookie } from 'lucide-react';
import { useCookieConsent } from '@/contexts/CookieConsentContext';

export default function AppFooter() {
  const ano = new Date().getFullYear();
  const { abrirPreferencias } = useCookieConsent();

  return (
    <footer className="border-t bg-card/50 px-6 py-4 mt-8">
      <div className="flex flex-col items-center justify-between gap-2 text-xs text-muted-foreground sm:flex-row">
        <span>© {ano} Performance RH. Todos os direitos reservados.</span>
        <div className="flex items-center gap-4">
          <button
            type="button"
            onClick={abrirPreferencias}
            className="inline-flex items-center gap-1.5 font-medium text-foreground/80 underline-offset-4 hover:text-primary hover:underline"
          >
            <Cookie className="h-3.5 w-3.5" />
            Preferências de cookies
          </button>
          <Link
            to="/privacidade"
            className="inline-flex items-center gap-1.5 font-medium text-foreground/80 underline-offset-4 hover:text-primary hover:underline"
          >
            <ShieldCheck className="h-3.5 w-3.5" />
            Política de Privacidade
          </Link>
        </div>
      </div>
    </footer>
  );
}
